// @flow

import { withPageMeta } from '@gandi/app-runner';

import { useScrollSpy } from 'src/hooks/useScrollSpy';

import PreferencesWidget from '../Layout/components/PreferencesWidget/PreferencesWidget';
import { Layout } from '../components/Layout';
import type { PreFetchArgs, FullState } from '../types';

import { BulkResult } from './components/BulkResult';
import { Header } from './components/Header';

import {
  ActiveKindContext,
  type ActiveKind,
} from './components/context/ActiveKindContext';

const SECTION_IDS: $ReadOnlyArray<
  'transferable' | 'creatable' | 'unavailable',
> = ['transferable', 'creatable', 'unavailable'];

const DomainTransferBulkResult = () => {
  const rawActiveId = useScrollSpy(SECTION_IDS, 17);
  const activeKind: ActiveKind = rawActiveId ?? null;
  return (
    <ActiveKindContext.Provider value={activeKind}>
      <Layout header={<Header />}>
        <BulkResult />
      </Layout>
    </ActiveKindContext.Provider>
  );
};

DomainTransferBulkResult.preFetch = function preFetch(
  args: PreFetchArgs<{}, void, empty, FullState>,
) {
  return Promise.allSettled([PreferencesWidget.preFetch(args)]);
};

export default (withPageMeta(({ __ }) => ({
  title: __('Domain name transfer - Gandi.net'),
  description: __(
    'Domain names - One of the largest catalogs of new TLDs, with free mailboxes and SSL certificate.',
  ),
}))(DomainTransferBulkResult): React.ComponentType<{}>);
